// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__Sstll","header":"MessagesList_header__2g_Gj","chat":"MessagesList_chat__PetEE"};